module.exports = __webpack_public_path__ + "static/img/fuwu3.f6b3bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productAndService/fuwu3.png
// module id = 67oy
// module chunks = 1